import { StyleSheet } from 'react-native';
import { BLUE_500, LILAC_200, WHITE, tokens } from '@airtel/air-design-system';
export var getStatusStripStyles = () => {
  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: tokens.spacing.SPACING_16,
      paddingVertical: tokens.spacing.SPACING_8,
      backgroundColor: LILAC_200
    },
    iconContainer: {
      paddingTop: tokens.spacing.SPACING_8,
      paddingBottom: tokens.spacing.SPACING_8,
      paddingRight: tokens.spacing.SPACING_8
    },
    textContainer: {
      flex: 1
    },
    countContainer: {
      backgroundColor: BLUE_500,
      marginHorizontal: tokens.spacing.SPACING_8,
      height: tokens.spacing.SPACING_16,
      width: tokens.spacing.SPACING_16,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_32,
      gap: tokens.spacing.SPACING_10,
      borderWidth: tokens.spacing.SPACING_1,
      borderColor: WHITE,
      alignItems: 'center',
      justifyContent: 'center'
    },
    icon: {
      flexShrink: 0
    }
  });
};